import type { LoyaltyEventCode } from "Infrastructure/Api/Api";
import { getCzechDateString } from "Utils/DateUtils";
import {
  getSessionStorageJSON,
  setSessionStorageJSON,
} from "Utils/Storage/SessionStorage/SecureSessionStorage";

type StoredEventData = {
  partyPublicIDs: string[];
  date: string;
};

export const canSendDailyEvent = (
  eventCode: LoyaltyEventCode,
  partyPublicID: string,
): boolean => {
  const storedData = getSessionStorageJSON<StoredEventData>(eventCode);
  const today = getCzechDateString();

  if (!storedData) {
    return true;
  }

  if (!storedData.partyPublicIDs.includes(partyPublicID)) {
    return true;
  }

  return storedData.date !== today;
};

export const setAnyDailyEventToStorage = (
  eventCode: LoyaltyEventCode,
  partyPublicID: string,
): void => {
  const today = getCzechDateString();
  const storedData = getSessionStorageJSON<StoredEventData>(eventCode);

  const eventData: StoredEventData = storedData ?? {
    partyPublicIDs: [],
    date: today,
  };

  const updatedEventData: StoredEventData = {
    partyPublicIDs: eventData.partyPublicIDs.includes(partyPublicID)
      ? eventData.partyPublicIDs
      : [...eventData.partyPublicIDs, partyPublicID],
    date: today,
  };

  setSessionStorageJSON(eventCode, updatedEventData);
};
